/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputVerifyTotpCodeRequest
 */
export interface InputVerifyTotpCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof InputVerifyTotpCodeRequest
     */
    code: string;
}

/**
 * Check if a given object implements the InputVerifyTotpCodeRequest interface.
 */
export function instanceOfInputVerifyTotpCodeRequest(value: object): boolean {
    if (!('code' in value)) return false;
    return true;
}

export function InputVerifyTotpCodeRequestFromJSON(json: any): InputVerifyTotpCodeRequest {
    return InputVerifyTotpCodeRequestFromJSONTyped(json, false);
}

export function InputVerifyTotpCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputVerifyTotpCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function InputVerifyTotpCodeRequestToJSON(value?: InputVerifyTotpCodeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
    };
}

